import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  Modal,
} from "react-bootstrap";
import { FacebookIcon, XIcon } from "react-share";
import { connect } from "react-redux";
import { createBrowserHistory } from "history";
import instagramIcon from "../../../img/instagram.png";
import youtubeIcon from "../../../img/youtube.png";
import { withRouter, Link } from "react-router-dom";
import {
  subscribeUser,
  authenticateCityPassword,
} from "../../../redux/actions/frontActions";
import "./Footer.css";
import moment from "moment";
import ReactHtmlParser from "react-html-parser";

import languageConfig from "../../../config/languageConfig";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const history = createBrowserHistory();
class Footer extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props, context) {
    super(props, context);
    this.state = {
      themeData: {},
      footerBgStyles: {},
      footerTextStyles: {},
      email: "",
      city_password: "",
      facebookPage: "",
      twitterPage: "",
      youtube_link: "",
      insta_link: "",
      showSubscriptionFrom: false,
      subscriptionResponse: false,
      showCityPasswordFrom: false,
      cityPasswordResponse: false,
      cityPasswordError: false,
      cityPasswordErrorStyle: { color: "red", fontWeight: "bold" },
      cityPasswordErrorMsg: "",
      siteName: "",
      hover: false,
      multi_lang: "no",
      lang: "",
      fontFamilies: "",
      default_lang: cookies.get("default_lang")
        ? cookies.get("default_lang")
        : "en",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCityPasswordSubmit = this.handleCityPasswordSubmit.bind(this);
    this.handleShowSubscriptionFrom =
      this.handleShowSubscriptionFrom.bind(this);
    this.handleCloseSubscriptionFrom =
      this.handleCloseSubscriptionFrom.bind(this);
    this.handleHideSubscriptionFrom =
      this.handleHideSubscriptionFrom.bind(this);
    this.handleShowCityPasswordFrom =
      this.handleShowCityPasswordFrom.bind(this);
    this.handleCloseCityPasswordFrom =
      this.handleCloseCityPasswordFrom.bind(this);
    this.handleHideCityPasswordFrom =
      this.handleHideCityPasswordFrom.bind(this);
  }

  hoverOn = (e) => {
    this.setState({
      hover: true,
      hoverID: e.target.attributes.getNamedItem("data-id").value,
    });
  };

  hoverOff = (e) => {
    this.setState({
      hover: false,
      hoverID: e.target.attributes.getNamedItem("data-id").value,
    });
  };

  handleCloseSubscriptionFrom() {
    localStorage.setItem("disableSubscriptionPopup", true);
    this.setState({ showSubscriptionFrom: false });
  }

  handleHideSubscriptionFrom() {
    localStorage.setItem("disableSubscriptionPopup", true);
  }

  handleShowSubscriptionFrom() {
    this.setState({ showSubscriptionFrom: true });
  }

  handleCloseCityPasswordFrom() {
    // localStorage.setItem('disableCityPasswordPopup', true);
    // this.setState({ showCityPasswordFrom: false });
  }

  handleHideCityPasswordFrom() {
    localStorage.setItem("disableCityPasswordPopup", true);
  }

  handleShowCityPasswordFrom() {
    this.setState({ showCityPasswordFrom: true });
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    siteData.default_lang = lang;
    localStorage.setItem("siteDDBStatus", JSON.stringify(siteData));
    this.setState({
      default_lang: lang,
    });

    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang);
    this.props.getMenuList({
      page: 1,
      lang: lang,
      cityID: siteData.default_city,
    });
    if (cookies.get("token")) {
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({ userKey: cookies.get("token"), lang: lang });
    }
  };

  handlePageChange = (page) => {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
        });
      }
    }

    this.setState({
      currentPage: page,
      cartTotal: 0,
    });
    if (cookies.get("token")) {
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
      this.props.getCartDetail({
        userKey: cookies.get("token"),
        lang:
          siteData && siteData.default_lang
            ? siteData.default_lang
            : this.state.default_lang,
      });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let checkDealID = cookies.get("affiliateID")
      ? cookies.get("affiliateID")
      : "";
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (siteData && siteData.default_city) {
      this.setState({ subscriptionResponse: true });
      const data = {
        city: [siteData.default_city],
        email: this.state.email,
        frequency: "",
        geo_subscriber: "yes",
        affiliateID: cookies.get("affiliateID") ? checkDealID.affiliateID : "",
        language: this.state.default_lang,
      };

      this.props.subscribeUser(data);
    } else {
      alert("Please select city.");
    }
  };

  handleCityPasswordSubmit = (e) => {
    e.preventDefault();
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (siteData && siteData.default_city) {
      const data = {
        siteID: siteData.siteID,
        cityID: siteData.default_city,
        password: this.state.city_password,
      };
      this.props.authenticateCityPassword(data);
    }
  };

  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    let disableSubscriptionPopup = localStorage.getItem(
      "disableSubscriptionPopup"
    )
      ? localStorage.getItem("disableSubscriptionPopup")
      : false;
    let accessibleCities = localStorage.getItem("accessibleCities")
      ? JSON.parse(localStorage.getItem("accessibleCities"))
      : [];

    // alert("Footer default_lang"+siteData.default_lang);
    // alert("Footer multi_lang"+siteData.multi_lang);
    // alert("Footer lang"+siteData.lang);

    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
        });
      }
    }

    if (siteData) {
      this.setState({ fontFamilies: siteData.font_families });
    }

    if (siteData) {
      this.setState({
        twitterPage: siteData.twitterPage,
        facebookPage: siteData.facebookPage,
        siteName: siteData.siteName,
        youtube_link: siteData.youtube_link,
        insta_link: siteData.insta_link,
      });
      let showCityPasswordFrom = true;
      if (
        siteData.password_protect == "active" &&
        this.props.match.path != "/login" &&
        this.props.match.path != "/register/"
      ) {
        const cityPasswordIndx = siteData.city_passwords.findIndex(
          (x) => x.cityID === siteData.default_city
        );
        const cityIndx = accessibleCities.findIndex(
          (x) => x.cityID === siteData.default_city
        );

        if (
          (cityIndx >= 0 && accessibleCities[cityIndx].status == true) ||
          cityPasswordIndx == -1
        ) {
          showCityPasswordFrom = false;
        }
        this.setState({ showCityPasswordFrom: showCityPasswordFrom });
      }
      if (
        !(siteData.password_protect == "active" && showCityPasswordFrom) &&
        siteData.popup_subscrbe == "enable" &&
        this.props.match.path == "/" &&
        disableSubscriptionPopup == false
      ) {
        this.setState({ showSubscriptionFrom: true });
      }
    }

    if (this.props.themeData) {
      this.setState({
        themeData: this.props.themeData,
      });

      if (this.props.themeData.menu_bar) {
        this.setState({
          menuBgStyles: {
            backgroundColor: this.props.themeData.menu_bar.menu_bar_color,
          },
        });
      } else {
        this.setState({
          menuBgStyles: {
            backgroundColor: "",
          },
        });
      }
      if (this.props.themeData.footer) {
        this.setState({
          footerBgStyles: {
            backgroundColor: this.props.themeData.footer.footer_color,
          },
          footerTextStyles: {
            color: this.props.themeData.footer.footer_text_color,
          },
          footer_social_link_color: {
            color: this.props.themeData.footer.footer_social_link_color,
          },
        });
      } else {
        this.setState({
          footerBgStyles: {
            backgroundColor: "",
          },
          footerTextStyles: {
            color: "",
          },
          footer_social_link_color: {
            color: "",
          },
        });
      }

      if (this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      } else {
        this.setState({
          button_color: "",
          mouseover_color: "",
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.language) {
      this.setState({ default_lang: nextProps.language });
    }
    if (nextProps.themeData) {
      this.setState({
        themeData: nextProps.themeData,
      });

      if (nextProps.themeData.menu_bar) {
        this.setState({
          menuBgStyles: {
            backgroundColor: nextProps.themeData.menu_bar.menu_bar_color,
          },
        });
      } else {
        this.setState({
          menuBgStyles: {
            backgroundColor: "",
          },
        });
      }
      if (nextProps.themeData.footer) {
        this.setState({
          footerBgStyles: {
            backgroundColor: nextProps.themeData.footer.footer_color,
          },
          footerTextStyles: {
            color: nextProps.themeData.footer.footer_text_color,
          },
          footer_social_link_color: {
            color: nextProps.themeData.footer.footer_social_link_color,
          },
        });
      } else {
        this.setState({
          footerBgStyles: {
            backgroundColor: "",
          },
          footerTextStyles: {
            color: "",
          },
          footer_social_link_color: {
            color: "",
          },
        });
      }

      if (nextProps.themeData.button) {
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      } else {
        this.setState({
          button_color: "",
          mouseover_color: "",
        });
      }
    }

    if (this.props.errorSubscriber != nextProps.errorSubscriber) {
      alert(nextProps.errorSubscriber);
      location.reload();
    }

    if (
      this.props.subscribeStatus != nextProps.subscribeStatus &&
      nextProps.subscribeStatus
    ) {
      if (nextProps.subscribeStatus.response == "success") {
        localStorage.setItem("disableSubscriptionPopup", true);
        this.setState({ showSubscriptionFrom: false });
      }
      alert(nextProps.subscribeStatus.message);
    }

    if (
      this.props.errorCityPasswordStatus != nextProps.errorCityPasswordStatus ||
      nextProps.errorCityPasswordStatus != ""
    ) {
      this.setState({
        cityPasswordError: true,
        cityPasswordErrorMsg: nextProps.errorCityPasswordStatus,
      });
    } else {
      this.setState({
        cityPasswordError: false,
        cityPasswordErrorMsg: "",
      });
    }

    if (
      this.props.cityPasswordStatus != nextProps.cityPasswordStatus &&
      nextProps.cityPasswordStatus
    ) {
      if (nextProps.cityPasswordStatus.response == "success") {
        localStorage.setItem("disableCityPasswordPopup", true);
        let accessibleCities = localStorage.getItem("accessibleCities")
          ? JSON.parse(localStorage.getItem("accessibleCities"))
          : [];
        let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
        if (accessibleCities.length <= 0) {
          accessibleCities = [{ cityID: siteData.default_city, status: true }];
        } else {
          const cityIndx = accessibleCities.findIndex(
            (x) => x.cityID === siteData.default_city
          );
          if (cityIndx >= 0) {
            accessibleCities[cityIndx].status = true;
          } else {
            accessibleCities.push({
              cityID: siteData.default_city,
              status: true,
            });
          }
        }
        const cities = JSON.stringify(accessibleCities);
        localStorage.setItem("accessibleCities", cities);
        this.setState({ showCityPasswordFrom: false });

        // After city password popup we need to show subscription popup
        let disableSubscriptionPopup = localStorage.getItem(
          "disableSubscriptionPopup"
        )
          ? localStorage.getItem("disableSubscriptionPopup")
          : false;
        if (
          siteData.popup_subscrbe == "enable" &&
          this.props.match.path == "/" &&
          disableSubscriptionPopup == false
        ) {
          this.setState({ showSubscriptionFrom: true });
        }
      }
    }
  }

  render() {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
 
    let city;
    //let sub_label;
    if (siteData) {
      const city = siteData.city_passwords.find(
        (cp) => cp.cityID == siteData.default_city
      );
    }

    const sub_label_en =
      siteData && siteData.default_lang == "en"
        ? siteData.sub_label_en
        : siteData.sub_label_en;
    const sub_label_fr =
      siteData && siteData.default_lang == "fr"
        ? siteData.sub_label_fr
        : siteData.sub_label_fr;
    const sub_button_en =
      siteData && siteData.default_lang == "en"
        ? siteData.sub_button_en
        : siteData.sub_button_en;
    const sub_button_fr =
      siteData && siteData.default_lang == "fr"
        ? siteData.sub_button_fr
        : siteData.sub_button_fr;
    const subscribe = siteData.subscribe;
    const selectedCityName = city ? city.title : "";
    return (
      <div>
        <div className="subscriber" style={this.state.menuBgStyles}>
          <div className="container">
            <Row>
              <Col lg={12} md={12} sm={12} xs={12} className="text-center">
                {siteData && siteData.postup == 0 && (
                  <Form inline onSubmit={this.handleSubmit}>
                    <FormGroup controlId="formInlineEmail">
       
                      <ControlLabel>
                        {
                         
                         subscribe && subscribe == "1"
                         ? this.state.default_lang == "en"
                           ? (sub_label_en ? sub_label_en :languageConfig[this.state.default_lang]
                             .subscribe_mailing)
                           : sub_label_fr ? sub_label_fr :languageConfig[this.state.default_lang]
                           .subscribe_mailing
                         : languageConfig[this.state.default_lang]
                             .subscribe_mailing
                       // languageConfig[this.state.default_lang]
                       //   .subscribe_mailing
                       //sub_label
                        }
                        :{" "}
                      </ControlLabel>{" "}
                      <FormControl
                        type="email"
                        name="email"
                        placeholder={
                          languageConfig[this.state.default_lang]
                            .optin_placeholder_text
                        }
                        required
                        onChange={this.handleChange}
                      />
                    </FormGroup>
                    <FormGroup controlId="button" className="subscription">
                      <Button
                        type="submit"
                        style={{
                          backgroundColor:
                            this.state.hover && this.state.hoverID == "subs"
                              ? this.state.mouseover_color
                              : this.state.button_color,
                        }}
                        data-id={"subs"}
                        onMouseEnter={this.hoverOn}
                        onMouseLeave={this.hoverOff}
                        className="cursor"
                      >
                        {
                          subscribe && subscribe == "1"
                            ? (this.state.default_lang == "en"
                              ? (sub_button_en ? sub_button_en :languageConfig[this.state.default_lang].subscribe)
                              : (sub_button_fr ? sub_button_fr :languageConfig[this.state.default_lang].subscribe))
                            : languageConfig[this.state.default_lang].subscribe
                           // languageConfig[this.state.default_lang]
                           //   .subscribe_mailing
                            //sub_label
                        }
                
                        {/* {languageConfig[this.state.default_lang].subscribe} */}
                      </Button>
                    </FormGroup>
                  </Form>
                )}
              </Col>
            </Row>
          </div>
        </div>
        <Modal
          style={{
            fontFamily: this.state.fontFamilies ? this.state.fontFamilies : "",
          }}
          show={this.state.showCityPasswordFrom}
          onHide={this.handleHideCityPasswordFrom}
          backdrop="static"
        >
          <Modal.Header onClick={this.handleCloseCityPasswordFrom}>
            <Modal.Title>
              {languageConfig[this.state.default_lang].ct_protc_pwd_ttl}
              <b>{selectedCityName && <span> {selectedCityName} </span>}</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h3>
              {languageConfig[this.state.default_lang].ct_protc_pwd_hd_1}
              <span>{this.state.siteName}</span>
              {languageConfig[this.state.default_lang].ct_protc_pwd_hd_2}
            </h3>
            <h5>{languageConfig[this.state.default_lang].ct_protc_pwd_text}</h5>
            <Form inline onSubmit={this.handleCityPasswordSubmit}>
              <FormGroup controlId="formInlineCityPassword">
                <ControlLabel> </ControlLabel>{" "}
                <FormControl
                  type="text"
                  name="city_password"
                  placeholder={languageConfig[this.state.default_lang].password}
                  required
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup controlId="button">
                <Button
                  type="submit"
                  style={{
                    backgroundColor:
                      this.state.hover && this.state.hoverID == "cribe"
                        ? this.state.mouseover_color
                        : this.state.button_color
                        ? this.state.button_color
                        : "#77C84E",
                  }}
                  data-id={"cribe"}
                  onMouseEnter={this.hoverOn}
                  onMouseLeave={this.hoverOff}
                  bsStyle="success"
                >
                  {languageConfig[this.state.default_lang].submit}
                </Button>
              </FormGroup>
              <div style={this.state.cityPasswordErrorStyle}>
                {this.state.cityPasswordError && (
                  <div>{this.state.cityPasswordErrorMsg}</div>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>
        <Modal
          style={{
            fontFamily: this.state.fontFamilies ? this.state.fontFamilies : "",
          }}
          show={this.state.showSubscriptionFrom}
          onHide={this.handleHideSubscriptionFrom}
          backdrop="static"
        >
          <Modal.Header closeButton onClick={this.handleCloseSubscriptionFrom}>
            <Modal.Title>
              {/* {languageConfig[this.state.default_lang].subscribe_mailing} */}
              {
                          subscribe && subscribe == "1"
                            ? this.state.default_lang == "en"
                              ? (sub_label_en ? sub_label_en :languageConfig[this.state.default_lang]
                                .subscribe_mailing)
                              : sub_label_fr ? sub_label_fr :languageConfig[this.state.default_lang]
                              .subscribe_mailing
                            : languageConfig[this.state.default_lang]
                                .subscribe_mailing
                          // languageConfig[this.state.default_lang]
                          //   .subscribe_mailing
                          //sub_label
                        }
                     
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form inline onSubmit={this.handleSubmit}>
              <FormGroup controlId="formInlineEmail">
                <ControlLabel> </ControlLabel>{" "}
                <FormControl
                  type="email"
                  name="email"
                  placeholder={
                    languageConfig[this.state.default_lang]
                      .optin_placeholder_text
                  }
                  required
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup controlId="button">
                <Button
                  type="submit"
                  style={{
                    backgroundColor:
                      this.state.hover && this.state.hoverID == "cribe"
                        ? this.state.mouseover_color
                        : this.state.button_color
                        ? this.state.button_color
                        : "#77C84E",
                  }}
                  data-id={"cribe"}
                  onMouseEnter={this.hoverOn}
                  onMouseLeave={this.hoverOff}
                  bsStyle="success"
                >
                  {/* {languageConfig[this.state.default_lang].subscribe} */}
                  {
                        subscribe && subscribe == "1"
                        ? (this.state.default_lang == "en"
                          ? (sub_button_en ? sub_button_en :languageConfig[this.state.default_lang].subscribe)
                          : (sub_button_fr ? sub_button_fr :languageConfig[this.state.default_lang].subscribe))
                        : languageConfig[this.state.default_lang].subscribe
                           // languageConfig[this.state.default_lang]
                           //   .subscribe_mailing
                            //sub_label
  }
                </Button>
              </FormGroup>
            </Form>
          </Modal.Body>
        </Modal>
        {siteData &&
        siteData.dynamic_footer == 1 &&
        siteData.footer_content.dynamic_footer_status == "enable" &&
        siteData.footer_content.french_footer_content !== "" &&
        this.state.default_lang == "fr" ? (
          ReactHtmlParser(siteData.footer_content.french_footer_content)
        ) : siteData &&
          siteData.dynamic_footer == 1 &&
          siteData.footer_content.dynamic_footer_status == "enable" &&
          siteData.footer_content.footer_content !== "" ? (
          ReactHtmlParser(siteData.footer_content.footer_content)
        ) : (
          <div className="footer" style={this.state.footerBgStyles}>
            <div className="container">
              <Row>
                <Col lg={3} md={3} sm={12} xs={12}>
                  <div>
                    <Button
                      bsStyle="link"
                      style={this.state.footerTextStyles}
                      onClick={() =>
                        this.context.router.history.push(`/aboutUs`)
                      }
                    >
                      {languageConfig[this.state.default_lang].about_us}
                    </Button>
                  </div>
                  <div>
                    <Button
                      bsStyle="link"
                      style={this.state.footerTextStyles}
                      onClick={() =>
                        this.context.router.history.push(`/contactUs`)
                      }
                    >
                      {languageConfig[this.state.default_lang].contact_us}
                    </Button>
                  </div>
                  <div>
                    <Button
                      bsStyle="link"
                      style={this.state.footerTextStyles}
                      onClick={() =>
                        this.context.router.history.push(`/become-partner`)
                      }
                    >
                      {languageConfig[this.state.default_lang].become_a_partner}
                    </Button>
                  </div>
                </Col>
                <Col lg={3} md={3} sm={12} xs={12}>
                  <div>
                    <Button
                      bsStyle="link"
                      style={this.state.footerTextStyles}
                      onClick={() =>
                        this.context.router.history.push(
                          `/subscription-manager`
                        )
                      }
                    >
                      {
                        languageConfig[this.state.default_lang]
                          .email_subscription
                      }
                    </Button>
                  </div>

                  <div>
                    <Button
                      bsStyle="link"
                      style={this.state.footerTextStyles}
                      onClick={() => this.context.router.history.push(`/faq`)}
                    >
                      {languageConfig[this.state.default_lang].faqs}
                    </Button>
                  </div>

                  {localStorage.getItem("user") ? (
                    <div>
                      {localStorage.getItem("userTypeName") === "customer" ? (
                        <Button
                          bsStyle="link"
                          style={this.state.footerTextStyles}
                          onClick={() =>
                            this.context.router.history.push(`/my-account`)
                          }
                        >
                          {languageConfig[this.state.default_lang].dashboard}
                        </Button>
                      ) : (
                        <Button
                          bsStyle="link"
                          style={this.state.footerTextStyles}
                          onClick={() =>
                            this.context.router.history.push(`/dashboard`)
                          }
                        >
                          {languageConfig[this.state.default_lang].dashboard}
                        </Button>
                      )}
                    </div>
                  ) : (
                    <div>
                      <Button
                        bsStyle="link"
                        style={this.state.footerTextStyles}
                        onClick={() =>
                          this.context.router.history.push(`/login`)
                        }
                      >
                        {languageConfig[this.state.default_lang].login}
                      </Button>
                    </div>
                  )}
                </Col>
                <Col lg={3} md={3} sm={12} xs={12}>
                  <div>
                    <Button
                      bsStyle="link"
                      style={this.state.footerTextStyles}
                      onClick={() =>
                        this.context.router.history.push(`/termsAndCondition`)
                      }
                    >
                      {
                        languageConfig[this.state.default_lang]
                          .term_and_condition
                      }
                    </Button>
                  </div>
                  <div>
                    <Button
                      bsStyle="link"
                      style={this.state.footerTextStyles}
                      onClick={() =>
                        this.context.router.history.push(`/privacyPolicy`)
                      }
                    >
                      {languageConfig[this.state.default_lang].privacy_policy}
                    </Button>
                  </div>
                </Col>
                <Col lg={3} md={3} sm={12} xs={12}>
                  {(this.state.facebookPage ||
                    this.state.twitterPage ||
                    this.state.insta_link ||
                    this.state.youtube_link) && (
                    <h4>
                      {languageConfig[this.state.default_lang].connect_with_us}
                    </h4>
                  )}
                  <div className="footer-social-icons">
                    {this.state.facebookPage && (
                      <a
                        href={this.state.facebookPage}
                        style={this.state.footer_social_link_color}
                        target="_blank"
                        className="facebook"
                      >
                        <FacebookIcon size={25} round={true} />
                      </a>
                    )}
                    {this.state.twitterPage && (
                      <a
                        href={this.state.twitterPage}
                        style={this.state.footer_social_link_color}
                        target="_blank"
                        className="twitter"
                      >
                        <XIcon size={25} round={true} />
                      </a>
                    )}
                    {this.state.insta_link && (
                      <a
                        href={this.state.insta_link}
                        style={this.state.footer_social_link_color}
                        target="_blank"
                        className="twitter"
                      >
                        <img
                          src={instagramIcon}
                          style={{ maxHeight: "25px", verticalAlign: "top" }}
                        />
                      </a>
                    )}
                    {this.state.youtube_link && (
                      <a
                        href={this.state.youtube_link}
                        style={this.state.footer_social_link_color}
                        target="_blank"
                        className="twitter"
                      >
                        <img
                          src={youtubeIcon}
                          style={{ maxHeight: "25px", verticalAlign: "top" }}
                        />
                      </a>
                    )}
                  </div>
                </Col>
                <Col md={12} xs={12}>
                  <hr />
                </Col>
                <Col
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className="text-center"
                  style={this.state.footerTextStyles}
                >
                  {languageConfig[this.state.default_lang].copyright}{" "}
                  {moment().format("YYYY")} {this.state.siteName}
                </Col>
              </Row>
            </div>
          </div>
        )}
      </div>
    );
  }
}

Footer.propTypes = {
  subscribeUser: PropTypes.func.isRequired,
  authenticateCityPassword: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  subscribeStatus: state.frontReducer.subscribeStatus,
  errorSubscriber: state.frontReducer.errorSubscriber,
  cityPasswordStatus: state.frontReducer.cityPasswordStatus,
  errorCityPasswordStatus: state.frontReducer.errorCityPasswordStatus,
});

export default withRouter(
  connect(mapStateToProps, { subscribeUser, authenticateCityPassword })(Footer)
);



// WEBPACK FOOTER //
// ./src/app/views/frontend/Footer/Footer.js